import React from "react";
import { useState } from "react";
import TablaGestion from "../../components/shared/layout/Table";
import { Catalogos } from "../../structure/Tables";
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import TravelExploreTwoToneIcon from '@mui/icons-material/TravelExploreTwoTone';
import KeyboardBackspaceTwoToneIcon from '@mui/icons-material/KeyboardBackspaceTwoTone';

export default function DetalleView(props){
    const {data, addRow, handleEditar,guardarRegistro, borrarRegistro, verCiudades, backOption,backFunction, title}=props;
    const [listaRegistro,setListaRegistros]=useState([])

    const [sortModel, setSortModel] = React.useState([
        {
          field: 'nombre',
          sort: 'asc',
        },
      ]);

    


    const botonesAccion = [
        {
        field: "action",
        headerName: <div  style={{marginBottom:"-10px"}}><AddTwoToneIcon titleAccess="Agregar" onClick={(e)=>addRow()}/></div>,
        width: 100,
        //width: 400,
        
        renderCell: (params) => {
            return (
            <div className="cellAction" style={{ display:"flex"}}>
                <div className="viewButton" style={{color:"#d7a200", border:"none"}} onClick={async(e)=>{
                if(!params.row.edit){params.row.idreal=await guardarRegistro(params.row, (backOption?"ciudad" : "detallecatalogo"))}; params.row.edit= !params.row.edit
                }} >{params.row.edit?<EditTwoToneIcon titleAccess="Editar" />: <SaveTwoToneIcon titleAccess="Guardar"/> }
                </div>
                <div className="viewButton" style={{color:"#d7a200", border:"none"}} 
                onClick={(e)=>{
                    borrarRegistro? borrarRegistro(params.row.idreal):e.preventDefault()
                }} ><DeleteTwoToneIcon titleAccess="Eliminar Detalle catálogo"/>
                </div>
            </div>
            );
        },
        },
    ];

    return(
        <React.Fragment>
            <TablaGestion 
                botones ={botonesAccion}
                data={data} 
                sortModel={sortModel} 
                setSortModel={setSortModel} 
                formato = {Catalogos} 
                titulo={<>
            {title}</>} 
            />
        </React.Fragment>
    )
}
